export default __webpack_public_path__ + "static/media/bg-image-nighttime.3c0b0370.jpg";